// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { ProductType } from './product-type';
import { SupplierImage } from './supplier-image';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class ProductTypeImage extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  /** Guid key */
  id!: string;
  /** String(200) */
  apiLink?: string;
  /** Boolean */
  isPrimary!: boolean;
  /** Boolean */
  isThumbnail!: boolean;
  /** Guid FK productType */
  productTypeId!: string;
  /** Binary */
  rowVersion!: any;
  /** Guid FK supplierImage */
  supplierImageId!: string;
  /** FK productTypeId */
  productType!: ProductType;
  /** FK supplierImageId */
  supplierImage!: SupplierImage;
}

